// extracted by mini-css-extract-plugin
export default {"FormControl":"default-issue-create-repository-section-module__FormControl--IZJX_","SelectedRepo":"default-issue-create-repository-section-module__SelectedRepo--Ntq5J"};